<template>
    <transition name="fade">
        <div v-if="isSaving" class="config-saving-indicator">
            <i class="fa-solid fa-circle-notch fa-spin"></i>
            {{ __('settings_saving') }}
        </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'

/**
 * Config Bus — indicatore UX di persistenza (Sprint 19, epic REFACTOR-030).
 *
 * Disaccoppia l'utente dai fallimenti silenziosi del vecchio `saveConfig`
 * (fire-and-forget): badge "salvataggio…" mentre un flush è in volo
 * (`status.saving`) e toast d'errore quando il POST fallisce — a quel punto il
 * Bus ha GIÀ fatto ROLLBACK delle chiavi dirty al loro snapshot confermato
 * (config.persistence.js), quindi il messaggio annuncia modifiche annullate.
 *
 * Montato in GeoFleet e GeoFleetMobile (un'istanza per vista).
 */
export default {
    name: 'ConfigSavingIndicator',
    computed: {
        ...mapGetters({
            isSaving: 'config/isSaving',
            saveError: 'config/error'
        })
    },
    watch: {
        saveError(error) {
            if (error) {
                this.$snotify.error(this.__('settings_save_error'), {
                    position: 'centerTop'
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.config-saving-indicator {
    position: fixed;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1060;
    padding: 4px 12px;
    border-radius: 999px;
    background: rgba(33, 37, 41, 0.85);
    color: #fff;
    font-size: 12px;
    pointer-events: none;

    i {
        margin-right: 4px;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
